module.exports = __webpack_public_path__ + "static/neo-74f73f88ed4e8b6ebf95ce201d7e4da4.png";